import React from "react";

export default function TickSvgIcon(Props) {
  return (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      onClick={Props.data?.onClick}
      aria-disabled={Props.data?.disable}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_10212_22506)">
        <rect
          x="2"
          y="1"
          rx="18"
          width="36"
          height="36"
          fill={Props.data?.class ? "#12B76A" : "white"}
        />
        <rect
          x="2.5"
          y="1.5"
          rx="17.5"
          width="35"
          height="35"
          stroke={Props.data?.class ? "white" : "#D0D5DD"}
        />
        <path
          stroke-width="1.67"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M26.6666 14L17.4999 23.1667L13.3333 19"
          stroke={Props.data.class ? "white" : "#667085"}
        />
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="40"
          height="40"
          id="filter0_d_10212_22506"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10212_22506"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_10212_22506"
          />
        </filter>
      </defs>
    </svg>
  );
}
